import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// import firebase from 'firebase/app'
// import 'firebase/auth'
// import firestore from './firebase'

import axios from 'axios'
import moment from 'moment'

import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

import fontawesome from '@fortawesome/fontawesome'
import faRegular from '@fortawesome/fontawesome-free-regular'
import faSolid from '@fortawesome/fontawesome-free-solid'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import '@/assets/style.css'
import { Utils } from './utils'
import api from './utils/api.js'
import './utils/filters.js'

Vue.config.productionTip = false

// Vue.prototype.$firestore = firestore
Vue.prototype.$http = axios
Vue.prototype.$utils = Utils
Vue.prototype.$moment = moment
Vue.prototype.$api = api

fontawesome.library.add(faRegular, faSolid)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(Buefy)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
